import { NavLink } from "react-router-dom";
import { Flame, Heart, User } from "lucide-react";
import { useAuth } from "../lib/auth";
import { t } from "../lib/i18n";

export default function BottomNav() {
  const { user } = useAuth();
  const lang = user?.language || "ru";
  const profileLabel = {
    ru: "Профиль",
    kk: "Профиль",
    be: "Профіль",
    uz: "Profil",
    ky: "Профиль",
  }[lang] || "Профиль";

  const items = [
    { to: "/discover", label: t(lang, "discover_kicker"), icon: Flame, testid: "nav-discover" },
    { to: "/matches", label: t(lang, "matches_kicker"), icon: Heart, testid: "nav-matches" },
    { to: "/profile", label: profileLabel, icon: User, testid: "nav-profile" },
  ];
  return (
    <nav className="bottom-nav absolute bottom-0 left-0 right-0 flex items-stretch justify-around px-2 pt-2 pb-3 z-30 safe-bottom">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          data-testid={it.testid}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center gap-1 py-2 rounded-2xl transition-colors ${
              isActive ? "text-[color:var(--peach-deep)]" : "text-[color:var(--ink-soft)]"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <it.icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} fill={isActive ? "currentColor" : "none"} />
              <span className="text-[10.5px] font-semibold">{it.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
